import { envs } from '@config'

import { datadogLogs } from './dd-logs'
import { Hermes } from './hermes'

const createLoggerInstance = () =>
  envs.isDevelopment || typeof document == 'undefined'
    ? console
    : datadogLogs.logger

const LoggerInstance = new Hermes(createLoggerInstance())

export default LoggerInstance
